<template>
  <div class="main-content">

    <EmptyCardModal
      v-if="modalNewCard"
      ref="exportXlsModal"
      :modalData="modalNewCard"
      :onModalClose="() => modalNewCard = null"
      :onModalAccept="() => saveNewCard()"
    >
      <slot>
        <NewCard :modalData="modalNewCard" ref="newCard"/>
      </slot>
    </EmptyCardModal>

    <div class="card">
      <div class="card-body">
        <!--        <div class="loading_screen" v-if="loadingCards">-->
        <pulse-loader :loading="loadingCards" :color="$constants.LOADING_COLOR" class="text-center"/>
        <!--        </div>-->

        <tabs class="tabs-default" :options="{ useUrlFragment: false }">
          <tab name="Карты">
            <div class="position-relative">
              <div class="flex justify-content-between mb-1">
                <div>
                  <p class="mb-0"><label><input @change="getCards(1)" type="checkbox" v-model="showInactiveCards">
                    показать карты в архиве</label></p>
                  <p class="mb-0"><label><input type="checkbox" v-model="sorting.id"> сортировать по ID</label></p>
                </div>
                <div class="flex">
                  <button @click="newCardModal" class="btn btn-outline-success mr-1">Добавить карту</button>
                  <button @click="getCards(1)" class="btn btn-outline-info">Обновить карты</button>
                </div>
              </div>
              <table class="table table-sm table-hover" v-if="cards">
                <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>Номер</th>
                  <th>Баланс</th>
                  <th>30 дней</th>
                  <th>Заявки</th>
                  <th></th>
                  <th>Сегодня</th>
                  <th>Владелец</th>
                  <th v-if="access.editCard">Доступ</th>
                  <th>Файлы<br/>Прокси</th>
                  <th width="200" v-if="access.editCard">Статус</th>
                  <th width="170" v-if="access.editCard"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(card, index) in getSortedCards()"
                    :class="{'no_active': card.status === 2,'disabled': !card.is_active}">
                  <td>{{ (index + 1) + ((currentPage - 1) * paginator.per_page) }}</td>
                  <td>{{ card.id }}</td>
                  <td>
                    <p>{{ card.number }}</p>
                    <p v-if="card.extra_options.status"><span
                      :class="{'badge': true, 'badge-info': card.extra_options.status === 'regular', 'badge-success': card.extra_options.status === 'professional'}">{{
                        getStatusName(card)
                      }}</span>
                    </p>
                    <p v-if="card.is_block"><span class="badge badge-danger">заблокировано</span></p>
                    <p v-if="card.is_block && card.block_time" class="text-muted fs-12">{{
                        printDate(card.block_time)
                      }}</p>
                    <!--                    <p>{{ useTypeAlias[card.use_type_id] }}</p>-->
                  </td>
                  <td>
                    <p>
                    <span
                      :class="{badge: true, 'badge-dark': +card.balance <= 30000, 'badge-warning': +card.balance > 30000}">{{
                        card.balance
                      }}</span>
                      <a v-if="card.type === 5" :href="`/storage/balance/balance_${card.id}.png?t=${Date.now()}`"
                         target="_blank">screen</a>
                    </p>
                  </td>
                  <td><span
                    :class="{'badge': true,
                    'badge-warning': (incomeTraffic[card.id] || 0) > 150000,
                    'badge-dark': (incomeTraffic[card.id] || 0) < 150000}">{{ incomeTraffic[card.id] || 0 }}</span>
                  </td>
                  <td>
                    <p><span class="badge badge-success">{{ cardPaidPending[card.id] }}</span></p>
                    <p v-if="cardsOrders[card.id]">
                      <a href="#"
                         @click.prevent="openInNewPage('searchOrder', {ordersId: cardsOrders[card.id]})">
                        Заявки <strong>{{ cardsOrders[card.id].length }}</strong>
                      </a>
                    </p>
                  </td>
                  <td>
                    <p>{{ types[card.type] }}
                      <button v-if="card.balance_date" @click="resetBalanceDate(card.id, index)"
                              class="btn btn-xs btn-outline-info"><i class="icon-fa icon-fa-refresh"/></button>
                    </p>
                    <p v-if="card.balance_date"
                       :class="{'text-muted':true,'badge badge-warning': outdatedCheck(card.balance_date)}">
                      {{ printDate(card.balance_date) }}</p>
                  </td>
                  <td>
                    <p v-if="transactions[card.id]?.incomes?.length"><span class="badge badge-info">+</span>:
                      <strong>{{ transactions[card.id].incomes.length }}</strong>
                      ({{ transactions[card.id].incomes.reduce((acc, t) => acc + t.sum, 0) }})</p>
                    <p v-if="transactions[card.id]?.outcomes?.length"><span class="badge badge-success">-</span>:
                      <strong>{{ transactions[card.id].outcomes.length }}</strong>
                      ({{ transactions[card.id].outcomes.reduce((acc, t) => acc + t.sum, 0) }})</p>
                  </td>
                  <td>
                    <p v-if="card?.owner?.short_name">{{ card.owner.short_name }}</p>
                    <p class="text-muted">{{ printDate(card.created_at, 'DD.MM.YYYY') }}</p>
                  </td>
                  <td v-if="access.editCard">
                    <button v-if="!showAccess[card.id]" @click="showAccess[card.id] = true" class="btn btn-default">
                      показать
                      доступ
                    </button>
                    <template v-if="showAccess[card.id]">
                      <p>{{ card?.owner?.banking_login }}</p>
                      <p>{{ card?.extra_options?.password || card?.owner?.banking_password }}</p>
                    </template>
                  </td>
                  <td>
                    <p v-for="file in card.files" v-if="file.is_active">
                      <a v-on:click.prevent="downloadFile(file)" href="#">{{ file.file_name }}</a>
                    </p>
                    <div v-for="p in card.proxy">
                      <p>{{ p.id }}
                        <template v-if="access.editCard && checkProxyDateDate(p, 'warning')">
                          <LoadingButton
                            title="Продлить"
                            type="button"
                            :loading="updateLoading"
                            :color="$constants.PRIMARY_COLOR"
                            :onClick="() => updateProxyExpire(p)"
                            className="btn btn-outline-info btn-xs"
                          />
                        </template>
                      </p>
                      <p>{{ p.ip }}:{{ p.port }}</p>
                      <p><span
                        :class="{'badge badge-warning': checkProxyDateDate(p, 'warning'), 'badge badge-danger': checkProxyDateDate(p, 'danger')}">({{
                          printDate(p.valid_date, 'DD.MM.YYYY')
                        }})</span>
                      </p>
                    </div>
                  </td>
                  <td v-if="access.editCard">
                    <select @change="updateCard(card)" v-model="card.status" class="form-control">
                      <option v-for="s in statuses" :value="s.id">{{ s.title }}</option>
                    </select>
                  </td>
                  <td v-if="access.editCard" align="right">
                    <template v-if="card.is_active">
                      <template v-if="updateLoadingButtons && updateLoadingButtons[card.id]">
                        <clip-loader :loading="true" size="18px"/>
                      </template>
                      <template v-else>
                        <button @click="editCard(card)" class="btn btn-xs btn-outline-info">редактировать</button>
                        <button @click="deactivateCard(card)" class="btn btn-xs btn-outline-warning">деактивировать
                        </button>
                      </template>
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="text-right">
                <paginate v-if="paginator"
                          v-model="paginator.current_page"
                          :page-count="paginator.last_page"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="getCards"
                          :prev-text="'&laquo'"
                          :next-text="'&raquo'"
                          :container-class="'pagination'"
                          :prev-class="'page-item'"
                          :prev-link-class="'page-link'"
                          :page-class="'page-item'"
                          :page-link-class="'page-link'"
                          :next-class="'page-item'"
                          :next-link-class="'page-link'"
                          :active-class="'active green_btn'">
                </paginate>
              </div>

              <div class="card editBlock" v-if="editCardData">
                <div class="card-header">
                  <h4>Редактирование карты</h4>
                </div>
                <div class="card-body">
                  <form action="" @submit.prevent="() => saveCard(null, true)">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="">Номер карты</label>
                          <div class="input-group">
                            <input type="text" class="form-control" required
                                   placeholder="Номер карты"
                                   disabled
                                   v-model="editCardData.number">
                            <div class="input-group-append">
                              <select v-model="editCardData.type" class="form-control">
                                <option value="1">VISA</option>
                                <option value="2">MASTER</option>
                                <option value="3">МИР</option>
                              </select>
                            </div>
                          </div>
                          <small class="form-text text-danger" v-if="errors.has('number')">
                            {{ errors.first('number') }}
                          </small>
                        </div>
                        <div class="form-group">
                          <label>Владелец</label>
                          <select v-model="editCardData.user_id" class="form-control">
                            <option v-for="u in users" :value="u.id">{{ u.full_name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Финансовый телефон</label>
                          <select v-model="editCardData.phone_id" class="form-control">
                            <option v-for="p in phones" :value="p.id">{{ p.phone_number }} ({{ p.slot }})</option>
                          </select>
                        </div>
                        <!--                        <div class="form-group">-->
                        <!--                          <label>Комментарий</label>-->
                        <!--                          <input type="text" placeholder="Комментарий" v-model="editCardData.owner.comment"-->
                        <!--                                 class="form-control">-->
                        <!--                        </div>-->
                      </div>
                      <div class="col-md-4">
                        <UploadImages
                          ref="editFiles"
                        />
                      </div>
                    </div>
                    <div class="text-right">
                      <LoadingButton
                        title="Сохранить"
                        type="submit"
                        className="btn btn-outline-success"
                        :onClick="() => {}"
                        :loading="loadingBtn"
                        :color="$constants.SUCCESS_COLOR"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </tab>
          <tab name="Телефоны">
            <CardsPhones :phones="phones" :updatePhones="(p) => phones = [...p]"/>
          </tab>
          <tab name="Владельцы карт">
            <CardsUsers :users="users" :updateUser="(u) => updateUser(u)"/>
          </tab>
          <tab name="Балланс на картах">
            <BalanceSms :cards="cards"/>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import {mask} from 'vue-the-mask'
import LoadingButton from "@/components/buttons/LoadingButton";
import Paginate from 'vuejs-paginate'
import UploadImages from "@/components/uploads/UploadImages";
import {Tabs, Tab} from 'vue-tabs-component'
import CardsPhones from "@/views/admin/settings/cards/components/CardsPhones";
import CardsUsers from "@/views/admin/settings/cards/components/CardsUsers";
import BalanceSms from "@/views/admin/settings/cards/components/BalanceSms.vue";
import EmptyCardModal from "@/components/modals/EmptyCardModal.vue";
import NewCard from "@/views/cards/components/NewCard.vue";
import moment from 'moment';

export default {
  directives: {
    mask
  },
  components: {
    BalanceSms,
    CardsPhones,
    Tabs, Tab,
    LoadingButton,
    Paginate,
    UploadImages,
    CardsUsers,
    EmptyCardModal,
    NewCard,
  },
  data() {
    return {
      modalNewCard: null,
      showInactiveCards: false,
      updateLoading: false,
      showAccess: {},
      sorting: {
        id: false,
      },
      statuses: [
        {id: 1, title: 'Активная карта'},
        {id: 2, title: 'Не используется'},
        {id: 3, title: 'Не используется но обновляется'}
      ],
      useTypeAlias: {
        1: 'почтовые поступления',
        2: 'предоплата доставочных',
        3: 'предоплата регионов',
      },
      newCardBlock: false,
      phones: [],
      paginator: null,
      currentPage: 1,
      loadingCards: false,
      updateLoadingButtons: {},
      loadingBtn: false,
      cards: null,
      types: {
        1: 'VISA',
        2: 'MASTER',
        3: 'МИР',
        5: 'QiWi',
        // 6: 'Открытие',
      },
      access: {
        editCard: false,
      },
      incomeTraffic: {},
      downloadedFiles: {},
      transactions: {},
      editCardData: null,
      cardPaidPending: {},
      cardsOrders: {},
      users: [],
      newCard: {
        use_type_id: 1,
        number: null,
        type: 1,
        owner: {
          phone_login: null,
          phone_pass: null,
          name: null,
          login: null,
          password: null,
          phone: null,
        }
      },
    }
  },
  async mounted() {
    if (this.$currentRole === 'admin') {
      this.access.editCard = true;
    }
    await this.getCards();
  },
  methods: {
    async updateProxyExpire(proxy) {
      this.updateLoading = true;
      const {data} = await api.post('cards/proxy/update', {
        action: 'extendExpire',
        proxy
      })
      if (data.success) {
        const index = this.cards.findIndex((c) => c.proxy[0].id === data.record.id);
        if (index !== -1) {
          this.cards[index].proxy[0] = data.record;
        }
      }
      this.updateLoading = false;
    },
    getStatusName(card) {
      switch (card.extra_options.status) {
        case 'regular':
          return 'основной';
        case 'professional':
          return 'професиональный'
        default:
          return ''
      }
    },
    getSortedCards() {
      if (this.sorting.id) return _.orderBy(this.cards, 'id', 'desc');
      return this.cards;
    },
    async resetBalanceDate(cardId, index) {
      this.cards[index].balance_date = null;
      const {data} = await api.post('/cards/updateCard', {
        action: 'resetBalanceTime',
        card: {id: cardId},
      });
    },
    outdatedCheck(date) {
      const diff = moment().diff(moment(date), 'minutes');
      return diff >= 30;
    },
    checkProxyDateDate(proxy, period) {
      const diff = moment().diff(moment(proxy.valid_date), 'days');
      switch (period) {
        case 'danger':
          return diff >= 0;
        case 'warning':
          return diff >= -3;
      }
      return false;
    },
    saveNewCard() {
      this.$refs.newCard.$refs.submit.click();
    },
    newCardModal() {
      this.modalNewCard = {
        header: 'Добавление новой карты',
        acceptBtnLoading: false,
      };
    },
    updateUser(user) {
      const index = this.users.findIndex((u) => u.id === user.id);
      if (index === -1) {
        this.users.push(user);
      } else {
        this.users[index] = user;
      }
      this.users = [...this.users];
    },
    editCard(card) {
      this.editCardData = card;
      setTimeout(() => {
        const el = this.$el.getElementsByClassName('editBlock')[0];
        if (el) {
          el.scrollIntoView({behavior: 'smooth'});
        }
      }, 300)
    },
    async downloadFile(file) {
      let link;
      if (!this.downloadedFiles[file.id]) {
        this.downloadedFiles[file.id] = {};
        this.downloadedFiles = {...this.downloadedFiles};
        let {data} = await api.index('/uploads/getImgLinkByKey?key=' + file.path);
        if (data.success) {
          link = data.link
          this.downloadedFiles[file.id].link = data.link;
        } else {
          toastr['warning'](data.message, 'Ошибка!')
        }
      } else {
        link = this.downloadedFiles[file.id].link;
      }
      window.open(link, '_blank');
    },
    async updateCard(card) {
      let {data} = await api.post('/cards/updateCard', {
        action: 'updateCard',
        card: card,
      });
      if (data.success) {
        toastr['success'](data.message, 'Сохранено!')
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
    },
    async deactivateCard(card) {
      this.updateLoadingButtons[card.id] = true;
      let {data} = await api.post('/cards/updateCard', {
        action: 'deactivateCard',
        card: card,
      });
      if (data.success) {
        toastr['success'](data.message, 'Сохранено!')
        this.getCards(this.currentPage);
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
      this.updateLoadingButtons[card.id] = false;
    },
    async saveCard(e, update = false) {
      this.loadingBtn = true;
      let {data} = await api.post('/cards/updateCard', {
        action: update ? 'updateCard' : 'newCard',
        card: update ? this.editCardData : this.newCard,
        files: update ? this.$refs.files?.editFiles : this.$refs.files.uploadedFiles
      });
      if (!data.success) {
        toastr['warning'](data.message, 'Ошибка!')
      } else {
        toastr['success'](data.message, 'Сохранено!')
        this.getCards();
      }
      this.editCardData = null;
      this.loadingBtn = false;
    },
    async getCards(page = 1) {
      this.loadingCards = true;
      let {data: r_data} = await api.index('/cards/getCards?page=' + page + '&typeIdOnly=5&sortBalance=1&disabled=' + +this.showInactiveCards);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.currentPage = this.paginator.current_page;
        this.showAccess = data.reduce((acc, r) => {
          acc[r.id] = false;
          return acc;
        }, {})
        this.updateLoadingButtons = data.reduce((acc, c) => {
          acc[c.id] = false;
          return acc;
        }, {})
        this.incomeTraffic = r_data.incomeTraffic;
        this.cardsOrders = r_data.cardsOrders;
        this.cardPaidPending = r_data.cardPaidPending;
        this.transactions = r_data.transactions;
        this.cards = data;
        if (r_data.users && r_data.users.length) {
          this.users = r_data.users;
        }
      } else {
        toastr['warning'](r_data.message, 'Ошибка!')
      }
      this.loadingCards = false;
    },
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 5px;
}

tr.no_active {
  opacity: .5;
}

.text-right {
  text-align: right;
}

.p-t-20 {
  padding-top: 20px;
}

.loading_screen {
  position: absolute;
  width: 100%;
  background-color: white;
  opacity: .7;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-xs {
  padding: 3px 5px !important;
}

tr.disabled {
  background-color: lightgray;
}

.v-spinner {
  text-align: right;
}
</style>
